module.exports = __webpack_public_path__ + "static/media/Progress1v2.25f3cfe6.png";